<div class="org-users-view">
  <div class="org-users-view__header">
    <span class="org-users-view__explore">Explore</span>
    <h2 class="org-users-view__title">Users</h2>
  </div>

  @if (state.loading()) {
    <div class="org-users-view__loading" role="status" aria-live="polite" aria-label="Loading users">
      <ngkit-progress-spinner [size]="32"></ngkit-progress-spinner>
      <span>Loading users...</span>
    </div>
  } @else if (state.error()) {
    <div class="org-users-view__error" role="alert">
      <p>Something went wrong</p>
      <p class="org-users-view__error-detail">{{ state.error() }}</p>
    </div>
  } @else if (!state.hasUsers()) {
    <div class="org-users-view__empty" role="status">
      <p>No users found in this organisation.</p>
    </div>
  } @else {
    <div class="org-users-view__actions">
      <div class="org-users-view__actions-left">
        <div class="org-users-view__search-wrap ngkit-flex-container-column ngkit-gap--xxxxxs">
          <ngkit-search
            class="org-users-view__search ngkit-width-full"
            placeholder="Find a user"
            [prepopulatedSearchQuery]="searchQuery()"
            (searchUpdated)="onSearch($event)"
            (searchCleared)="clearSearch()"
          />
        </div>
        <div class="org-users-view__identity-filter ngkit-flex-container-column ngkit-gap--xxxxxs">
          <p-selectButton
            class="ngkit-selecttag"
            [options]="identityTypeFilterOptions"
            [allowEmpty]="false"
            optionLabel="label"
            optionValue="value"
            [ngModel]="identityTypeFilter()"
            (ngModelChange)="onIdentityTypeFilterChange($event)"
          />
        </div>
      </div>
      <div class="org-users-view__actions-right">
        @if (showRemoveButton()) {
          <p-button
            [label]="removeButtonLabel()"
            [disabled]="removeButtonDisabled()"
            severity="danger"
            (onClick)="openRemoveDialog()"
            [attr.aria-label]="removeButtonLabel()"
          ></p-button>
        }
      </div>
    </div>

    @if (state.removeSuccess()) {
      <div class="org-users-view__success" role="status">
        <p>{{ state.removeSuccess() }}</p>
        <button
          type="button"
          class="org-users-view__success-dismiss"
          aria-label="Dismiss success message"
          (click)="dismissSuccess()"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    }

    <div class="org-users-view__content">
      <div class="org-users-view__table-wrap">
        @if (!hasSearchResults()) {
          <div class="org-users-view__no-results" role="status">
            <p>No users match your search.</p>
          </div>
        } @else {
          <p-table
            [value]="filteredUsers()"
            [scrollable]="true"
            scrollHeight="flex"
            sortField="displayName"
            [defaultSortOrder]="1"
            [customSort]="true"
            (sortFunction)="customSort($event)"
            class="ngkit-table org-users-view__table"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="col-checkbox" (click)="$event.stopPropagation()">
                  <p-checkbox
                    [ngModel]="allSelected()"
                    [binary]="true"
                    [indeterminate]="someSelected()"
                    (onChange)="toggleAll()"
                    inputId="selectAll"
                    ariaLabel="Select all users"
                  >
                  </p-checkbox>
                </th>
                <th class="col-name" pSortableColumn="displayName">
                  <p-sortIcon field="displayName" />
                  Display Name
                </th>
                <th class="col-actions"></th>
                <th class="col-email" pSortableColumn="email">
                  <p-sortIcon field="email" />
                  Email
                </th>
                <th class="col-type" pSortableColumn="type">
                  <p-sortIcon field="type" />
                  Type
                </th>
          </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr
                class="org-users-view__row"
                [class.org-users-view__row--active]="selectedRowId() === row.id"
                [class.org-users-view__row--clickable]="row.type === 'user'"
                [class.org-users-view__row--service]="row.type === entityType.M2M"
                (click)="selectRow(row)"
              >
                <td class="col-checkbox" (click)="$event.stopPropagation()">
                  <p-checkbox
                    [ngModel]="isSelected(row.id)"
                    [binary]="true"
                    (onChange)="toggleRow(row.id)"
                    [inputId]="'select-' + row.id"
                    [ariaLabel]="'Select ' + row.displayName"
                    [disabled]="row.type === entityType.M2M"
                  >
                  </p-checkbox>
                </td>
                <td data-col="displayName">
                  <span class="name-cell min-width-0">
                    <fga-icon
                      class="row-icon"
                      [name]="row.type"
                      [size]="12"
                      [ariaLabel]="row.type === entityType.M2M ? 'Machine identity' : null"
                    />
                    <span class="row-name text-truncate min-width-0" [fgaEllipsisTitle]="row.displayName">
                      {{ row.displayName }}
                    </span>
                  </span>
                </td>
                <td class="col-actions" (click)="$event.stopPropagation()">
              @if (row.type === 'user') {
                <p-button
                  styleClass="ngkit-button"
                  severity="secondary"
                  variant="text"
                  icon="pi ds-ngkit-delete"
                  [disabled]="state.removing()"
                  (onClick)="openRowRemoveDialog(row)"
                  pTooltip="Remove user"
                  tooltipPosition="top"
                  tooltipEvent="both"
                  [ariaLabel]="'Remove user ' + row.displayName"
                />
              }
            </td>
                <td data-col="email">
                  <span class="text-truncate" [fgaEllipsisTitle]="row.email">{{ row.email }}</span>
                </td>
                <td data-col="type">
                  <span class="type-badge">
                    {{ row.type === entityType.M2M ? 'Service' : 'User' }}
                  </span>
                </td>
          </tr>
            </ng-template>
          </p-table>
        }
      </div>

    </div>
  }
</div>

@if (selectedRow()) {
  <p-drawer
    [visible]="true"
    (onHide)="closeDetailsPanel()"
    position="right"
    styleClass="org-users-details-panel"
  >
    <ng-template pTemplate="header">
      <div class="ngkit-flex-container-column">
        <span class="org-users-details-panel__title">Groups</span>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="org-users-details-panel__content">
        <p class="org-users-details-panel__user" [fgaEllipsisTitle]="selectedRow()!.displayName">
          {{ selectedRow()!.displayName }}
        </p>

        <ngkit-search
          class="org-users-details-panel__filter ngkit-width-full"
          placeholder="Filter groups"
          [prepopulatedSearchQuery]="groupsFilterQuery()"
          (searchUpdated)="groupsFilterQuery.set($event ?? '')"
          (searchCleared)="clearGroupsFilter()"
        />

        <div class="org-users-details-panel__list" role="region" aria-label="Groups list">
          @if (groupsLoading()) {
            <p class="org-users-details-panel__empty">Loading groups...</p>
          } @else if (groupsError()) {
            <p class="org-users-details-panel__error" role="alert">{{ groupsError() }}</p>
          } @else if (selectedUserGroups().length === 0) {
            <p class="org-users-details-panel__empty">No groups found.</p>
          } @else {
            <ul>
              @for (groupName of selectedUserGroups(); track groupName) {
                <li>{{ groupName }}</li>
              }
            </ul>
          }
        </div>
      </div>
    </ng-template>
  </p-drawer>
}

<p-dialog
  [visible]="confirmDialogOpen()"
  (visibleChange)="confirmDialogOpen.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!state.removing()"
  [closeOnEscape]="!state.removing()"
  (onHide)="cancelRemove()"
  [style]="{ width: '32rem' }"
  styleClass="org-users-view__dialog"
  header="Confirm removal"
>
  <div class="org-users-view__dialog-body">
    <p id="org-users-remove-dialog-title" class="org-users-view__dialog-lead">
      Remove the following
      {{ removalTargets().length === 1 ? 'user' : 'users' }} from this organisation?
    </p>

    <dl class="org-users-view__dialog-org">
      <dt>Organisation</dt>
      <dd>{{ organisationName || organisationId }}</dd>
    </dl>

    <h3 class="org-users-view__dialog-subtitle">
      Users to remove ({{ removalTargets().length }})
    </h3>
    <ul class="org-users-view__dialog-users">
      @for (user of removalTargets(); track user.id) {
        <li>{{ user.displayName }}</li>
      }
    </ul>

    <p class="org-users-view__dialog-warning">
      This will immediately revoke access to this organisation and invalidate active
      sessions.
    </p>
    <p class="org-users-view__dialog-warning org-users-view__dialog-warning--irreversible">
      This action is hard to reverse and may require Operational Support.
    </p>

    @if (state.removeError()) {
      <div class="org-users-view__remove-error" role="alert">
        <p>{{ state.removeError() }}</p>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      severity="secondary"
      [disabled]="state.removing()"
      (onClick)="cancelRemove()"
    ></p-button>
    <p-button
      label="Confirm Removal"
      severity="danger"
      [loading]="state.removing()"
      [disabled]="state.removing()"
      (onClick)="removeSelectedUsers()"
      aria-label="Confirm Removal"
    ></p-button>
  </ng-template>
</p-dialog>
